import { OkeDeviceProvider, OkeFailoverProvider, OkeFrameProvider, OrderEngineProvider } from '@adamlip/okeoke.client.fastpay'
import { HeroUIProvider } from '@heroui/react'
import { LanguageProvider } from 'intl/languageContext'
import { createRoot } from 'react-dom/client'
import { ErrorBoundary } from 'react-error-boundary'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import RegisterDevice from 'views/RegisterDevice'
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import './style.css'
import './style.scss'
import { ErrorFallback } from './utils/ErrorHandler'

const root = createRoot(document.getElementById('root'))
root.render(
  <BrowserRouter>
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <OkeFrameProvider>
        <OkeFailoverProvider>
          <HeroUIProvider>
            <div style={{ height: '100vh', width: '100vw' }} >
              <ToastContainer />
              <LanguageProvider app='pos' group='main'>
                <OkeDeviceProvider prefix='pos' title='Pos' types={[1, 2, 3, 4, 5, 6]} CustomDeviceLogin={RegisterDevice} isActivate={true}>
                  <OrderEngineProvider>
                    <App />
                  </OrderEngineProvider>
                </OkeDeviceProvider>
              </LanguageProvider>
            </div>
          </HeroUIProvider>
        </OkeFailoverProvider>
      </OkeFrameProvider>
    </ErrorBoundary>
  </BrowserRouter>
)
serviceWorkerRegistration.register()
